import React from "react";
import className from "../../../shared/className";
import { observer } from "mobx-react";
import {
  getObPatientName,
  ObPatientLocation,
  ObPatientStatus,
} from "../ObSurveilPatient/ObPatientInfo";

export default observer(function PatientListItem({
  patient,
  specifics,
  draggedPatient,
  surveilStore,
  dragStart,
  dragEnter,
  onDrop,
  i,
}) {
  return (
    <div
      {...className({
        "patient-list-item": true,
        dragged: patient === draggedPatient,
        outside: i >= surveilStore.layout,
      })}
      draggable
      onDragStart={() => dragStart(patient)}
      onDragEnter={() => dragEnter(patient)}
      onDragOver={(e) => e.preventDefault()}
      onDrop={onDrop}
    >
      <div className="patient-info">
        <div className="name">
          {getObPatientName(surveilStore.showPHI, patient)}
        </div>
        <div className="location">
          <ObPatientLocation
            mrn={patient.mrn}
            unit={specifics.unit}
            bed={specifics.location}
          />
        </div>
        <div className="status">
          <ObPatientStatus specifics={specifics} />
        </div>
      </div>
    </div>
  );
});
